import { createFinanceStaffRequestPage } from './FinanceStaffRequestPortal';

const FinanceHostelMembers = createFinanceStaffRequestPage({
  apiBase: '/finance/hostel-members',
  addType: 'hostel_member_add',
  exitType: 'hostel_member_exit',
  reactivateType: 'hostel_member_reactivate',
  targetRole: 'hostel_member',
  entityLabel: 'Hostel Member',
  entityLabelPlural: 'Hostel Members',
  accent: '#ec4899',
  designationOptions: ['Warden', 'Assistant Warden', 'Mess In-Charge', 'Caretaker'],
});

export default FinanceHostelMembers;
